"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _components = require("@insided/shared/services/algolia/components");

var _classnames = _interopRequireDefault(require("classnames"));

var _common = require("@insided/shared/utils/common");

var type = function type(hit) {
  if (hit.content_type === 'question') return 'Question';
  if (hit.content_type === 'article') return 'Article';
  if (hit.content_type === 'ideation') return 'Idea';
  if (hit.content_type === 'event') return 'Event';
  if (hit.content_type === 'productUpdate') return 'Product Update';

  var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

  return isBugContentTypeEnabled ? 'Bug' : 'Discussion';
};

var HitContainerControl = function HitContainerControl(_ref) {
  var key = _ref.key,
      inputValue = _ref.inputValue,
      hits = _ref.hits,
      highlightedIndex = _ref.highlightedIndex,
      getItemProps = _ref.getItemProps,
      style = _ref.style,
      exclude = _ref.exclude,
      searchById = _ref.searchById,
      finalInput = _ref.finalInput;
  return (0, _preact.h)("div", {
    key: key !== null && key !== void 0 ? key : 'results',
    className: "algolia-hit-container",
    style: style
  }, inputValue && !hits.length ? (0, _preact.h)("div", {
    className: "algolia-hit-container__header"
  }, (0, _preact.h)("span", {
    className: "algolia-hit-container__header-text"
  }, "No result found for:"), " ", inputValue) : null, (0, _preact.h)("ul", {
    className: "algolia-search-results"
  }, hits.filter(function (hit) {
    if (!searchById) return hit;
    return hit.id === parseInt(finalInput) || hit.private_id === parseInt(finalInput);
  }).map(function (hit, index) {
    var hitCheck = "".concat(hit.content_type, "-").concat(hit.id);
    var disabled = typeof exclude !== 'undefined' && Array.isArray(exclude) && exclude.includes(hitCheck);
    return (0, _preact.h)("li", (0, _extends2.default)({
      key: hit.id,
      className: (0, _classnames.default)('algolia-search-result', {
        disabled: disabled
      }, {
        highlighted: highlightedIndex === index
      })
    }, getItemProps({
      item: hit,
      index: index,
      disabled: disabled
    })), (0, _preact.h)("span", {
      className: "algolia-hit-item"
    }, (0, _preact.h)(_components.Highlight, {
      attribute: "title",
      hit: hit,
      tagName: "strong"
    }), (0, _preact.h)("br", null), (0, _preact.h)("span", null, type(hit), " by ", hit.username)));
  })));
};

var _default = HitContainerControl;
exports.default = _default;